export default __webpack_public_path__ + "static/media/mediaid350_20200723.c337555b.jpg";